export enum PageState {
  Default,
  Creation,
  Edit
}